import React from "react";
import { useSelector } from "react-redux";
import { htmlPlainTextLength } from "../../../../utils/utils";
import RichTextEditore from "../../../ui/richTextEditore/RichTextEditore";
import classes from "./MessageRichTextEditor.module.css";

export const MESSAGE_CONTENT_HTML_LINK_WARNING_LENGTH = 900;

const MessageRichTextEditor = ({ value, onChange, maxLength = 100 }) => {

    const { texts } = useSelector((state) => state.translate);
    const hasError = hasMessageContentError(value, maxLength);
    const hasLinkLengthWarning = hasMessageContentLinkLengthWarning(value);

    return (
        <div className={classes.Wrap}>
            <label className={classes.Label}>
                {texts.MessageContent}
                {hasError && <span className={classes.RequiredStar}> *</span>}
            </label>
            <div className={classes.EditorWrap}>
                <RichTextEditore
                    value={value}
                    onChange={onChange}
                    placeholder={texts.writeHereInMessage}
                    rtl={true}
                    height={135}
                />
            </div>
            {hasLinkLengthWarning ?
                <p className={classes.ErrorText} role="alert">
                    {texts.messageContentLengthOverLimitText}
                </p>
                : null}
            <div className={`${classes.Counter} ${htmlPlainTextLength(value || "") > maxLength ? classes.CounterOver : ""}`}>
                {htmlPlainTextLength(value || "")}/{maxLength} {texts.charsUnit}
            </div>
        </div>
    );
};

export default MessageRichTextEditor;

export const hasMessageContentLinkLengthWarning = (value) =>
    (value || "").length > MESSAGE_CONTENT_HTML_LINK_WARNING_LENGTH;

export const hasMessageContentError = (value, maxLength) => { return !value || htmlPlainTextLength(value || "") > maxLength || hasMessageContentLinkLengthWarning(value); };
